import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ModalWindowComponent} from "../../std-components/modal-window/modal-window.component";
import {ServerService} from "../../shared/services/server.service";
import {OneFlatSalesSet2} from "../flats-modal/flats-modal.component";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
  selector: "app-typeofot",
  templateUrl: "./typeofot.component.html",
  styleUrls: ["./typeofot.component.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class TypeofotComponent implements OnInit {

  @Input() index: number;
  @Input() flatID: number;
  @Input() furnishListEx: OneFlatSalesSet2[] = [];

  @Output() selectedfurnishListEx: EventEmitter<OneFlatSalesSet2[]> = new EventEmitter<OneFlatSalesSet2[]>();

  loader: boolean = false;

  furnishArr: FlatFurnishTypesEx[] = [];
  furnishArrList: FlatFurnishTypes[] = [];
  selectedFurnishList: FlatFurnishTypes[] = [];
  selectedFurnishId: number = 0;
  furnishTypes;
  returnedData: FlatFurnishTypes[] = [];

  constructor( private modalWindow: ModalWindowComponent, private serverService: ServerService ) { }

  ngOnInit() {
    this.fillReturnedData();
    this.loadData();
  }

  fillReturnedData() {
    this.furnishListEx.map((r, i) => {
      this.returnedData.push({
        id: r.furnishItemID,
        title: r.furnishItemTitle,
        checked: true
      });
    });
  }

  loadData() {
    this.loader = true;
    this.serverService.getFlatFurnishTypes().then(res1 => {
      if(res1) {
        this.serverService.getGetFlatFurnishType().then(res2 => {
          this.loader = false;
          this.furnishArrList = this.updateData2(this.furnishListEx, res2);

          this.furnishArr = this.updateData(res1, res2);
        });
      }
    });
  }

  saveSelectedValues(s: FlatFurnishTypes) {
    let find = this.returnedData.findIndex(f => f.id === s.id);
    if(find === -1) {
      this.returnedData.push({
        id: s.id,
        title: s.title,
        checked: s.checked
      });
    } else {
      delete this.returnedData[find];
    }
    this.returnedData = this.returnedData.filter(value => Object.keys(value).length !== 0);
  }

  deleteFurnishType(type: FlatFurnishTypes) {
    this.selectedFurnishList.find(f => f.id === type.id).checked = false;
    this.returnedData = this.returnedData.filter(f => f.id !== type.id);
  }

  updateArr(arr: FlatFurnishTypes[]) {
    let res: OneFlatSalesSet2[] = [];
    res = arr.map(r => {
      return {
        furnishItemID: r.id,
        furnishItemTitle: r.title
      }
    });
    return res;
  }

  updateData(rows1: FlatFurnishTypes[], rows2: FlatFurnishTypes[]) {
    let res: FlatFurnishTypesEx[] = [];
    res = rows1.map(r => {
      return {
        id: r.id,
        title: r.title,
        active: false,
        types: []
      }
    });

    res.forEach(r => {
      let types = rows2.filter(f => f.furnishTypeID === r.id);
      r.types = types.map(r2 => {
        return {
          id: r2.id,
          title: r2.title,
          furnishTypeID: r2.furnishTypeID,
          active: false
        }
      });
    });
    res[0].active = true;
    this.selectedFurnishList = rows2.filter(f => f.furnishTypeID === 1);

    return res;
  }

  updateData2(rows1: OneFlatSalesSet2[], rows2: FlatFurnishTypes[]) {
    rows2.forEach(f => {
      let r = rows1.findIndex(x => x.furnishItemID === f.id);
      f.checked = r !== -1 ? true : false;
    });
    return rows2;
  }

  selectFurnish(id: number) {
    if (this.selectedFurnishId === id) {
      this.furnishArr[id].active = true;
    } else {
      this.furnishArr[this.selectedFurnishId].active = false;
      this.selectedFurnishId = id;
      this.furnishArr[id].active = true;
    }
    this.selectedFurnishList = this.furnishArrList.filter(f => f.furnishTypeID === this.furnishArr[id].id);
  }

  confirm() {
    let res = this.updateArr(this.returnedData);
    this.selectedfurnishListEx.emit(res);
    this.modalWindow.closeModalWindow();
  }

  cancelModal() {
    this.modalWindow.closeModalWindow();
  }

}

export interface FlatFurnishTypes {
  id?: number;
  title?: string;
  furnishTypeID?: number;
  checked?: boolean;
}

export interface FlatFurnishTypesEx {
  id?: number;
  title?: string;
  active?: boolean;
  types?: FlatFurnishTypes[];
}



